import { Switchbox, SearchFilterPanel } from "@weirgroup/weir-dls";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { FilterType } from "../../../types/filter.type";
import "../styles.scss";
import { useDarkMode } from "../../../hooks/use-darkmode";

interface Props {
  setIsTableShown: Dispatch<SetStateAction<boolean>>;
  isTableShown: boolean;
  setSearchQuery: Dispatch<SetStateAction<string>>;
  filterAssets: any;
  filters: FilterType[];
  setFilters: Dispatch<SetStateAction<FilterType[]>>
}

export const Filter = (props: Props) => {
  const {
    setIsTableShown,
    isTableShown,
    setSearchQuery,
    filterAssets,
    filters,
    setFilters
  } = props

  const { t } = useTranslation();
  const {darkMode} = useDarkMode()
  const onChange = (event: any) => {
    let clonedFilters = filters;
    clonedFilters.forEach((filter) => {
      filter.type.forEach((item) => {
        if (item.title == event) {
          item.checked = !item.checked;
        }
      })
    })
    setFilters(clonedFilters);
    filterAssets();
  }

  return (
    <div className="filter-container">
      <div className="filter-row">
        <p style={{color:darkMode ? "white": "black"}}>Map View</p>
        <Switchbox
          darkMode={darkMode}
          name="tester"
          checked={isTableShown}
          label="Table View"
          onChange={() => {
            setIsTableShown(!isTableShown)
          }}
        />
      </div>
      <div className="filter-container">
        <SearchFilterPanel
          Label={t("enterSerialNumber")}
          darkMode={darkMode}
          ResultSet={filters}
          onSearchChange={(e: any) => setSearchQuery(e)}
          onSearchIconClick={(e: any) => {
            filterAssets()
          }}
          onCheckBoxChange={(e: any) => onChange(e)}
        />
      </div>
    </div>
  );
}

